import React, { Component } from 'react';
import { Form, Input, Label, SubLabel, Button, Dropdown } from '../../../Form';

import withTranslations from '../../../../utils/translations/withTranslations';

class DentalSystem extends Component {
  constructor(...props) {
    super(...props);

    this.state = {
      isValid: true
    };
  }

  next() {
    this.props.saveItem(this.form.formData());
    this.props.next();
  }

  render() {
    const { translate, data = {}, previous } = this.props;
    const { isValid } = this.state;

    return (
      <div className="DentalSystem">
        <Form
          ref={form => (this.form = form)}
          onValidationChange={valid => this.setState({ isValid: valid })}
          className="DentalSystem__Form"
        >
          <h1>{translate('fiche.dental_system.title')}</h1>
          <Label text={translate('fiche.dental_system.caries')} />
          <SubLabel text={translate('fiche.dental_system.caries_sub')} />
          <Input name="caries" defaultValue={data.caries} />

          <Label text={translate('fiche.dental_system.tooth_position')} />
          <SubLabel
            text={translate('fiche.dental_system.tooth_position_sub')}
          />
          <Input name="tooth_position" defaultValue={data.tooth_position} />

          <Label text={translate('fiche.dental_system.dental_prosthesis')} />
          <Dropdown
            name="dental_prosthesis"
            rules={['required']}
            defaultValue={data.dental_prosthesis}
            data={[
              { value: '-', label: translate('no') },
              { value: 'loose', label: translate('fiche.dental_system.loose') },
              { value: 'fixed', label: translate('fiche.dental_system.fixed') }
            ]}
          />

          <Label text={translate('fiche.dental_system.stomach')} />
          <SubLabel text={translate('fiche.dental_system.stomach_sub')} />
          <Input name="stomach" defaultValue={data.stomach} />

          <Label text={translate('fiche.dental_system.intestinal_tract')} />
          <SubLabel
            text={translate('fiche.dental_system.intestinal_tract_sub')}
          />
          <Input name="intestinal_tract" defaultValue={data.intestinal_tract} />

          <Button
            solid
            className="Form__Button"
            disabled={!isValid}
            onClick={() => this.next()}
          >
            {translate('fiche.next')}
          </Button>
          <Button
            transparant
            className="Form__Button"
            onClick={() => previous()}
          >
            {translate('fiche.previous')}
          </Button>
        </Form>
      </div>
    );
  }
}

export default withTranslations(DentalSystem);
